const values = [
  {
    icon: 'ri-heart-line',
    title: 'Family Promise',
    description: 'You are not a ticket or a transaction — you are family. We show up for our clients the way family does: with loyalty, genuine care, and a commitment to making sure you always feel supported, heard, and valued.'
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Designer-First Mindset',
    description: 'Every decision we make starts with one question: does this make a designer\'s life easier? Your success is the metric we optimize for.'
  },
  {
    icon: 'ri-links-line',
    title: 'Relationships That Matter',
    description: 'We\'ve spent years building trusted relationships with trade vendors across every category — so you get access to the best, every time.'
  },
  {
    icon: 'ri-leaf-line',
    title: 'Quality Without Compromise',
    description: 'We vet every vendor and product we work with. Your reputation is on the line with every project — and so is ours.'
  }
];

export default function MissionValues() {
  return (
    <section className="py-28 bg-[#F5F0EB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <p className="text-[#C5A572] text-sm font-semibold uppercase tracking-widest mb-4">What Drives Us</p>
          <h3 className="text-5xl font-bold text-[#2B2B2B] mb-6">
            Our Mission &<br />
            <span className="font-serif italic">Core Values</span>
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg leading-relaxed">
            Our mission is simple: to remove every operational obstacle standing between interior designers and the products they need — so great design can happen without friction.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {values.map((value) => (
            <div
              key={value.title}
              className="bg-white rounded-3xl p-10 flex gap-6 items-start"
            >
              <div className="w-14 h-14 bg-[#FAF8F5] rounded-2xl flex items-center justify-center flex-shrink-0 border border-[#C5A572]/20">
                <i className={`${value.icon} text-[#C5A572] text-2xl`}></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-[#2B2B2B] mb-3">{value.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
